module.exports = ["cent","copy","divide","gt","lt","not","para","times"]


//////////////////
// WEBPACK FOOTER
// ./~/stringify-entities/dangerous.json
// module id = 191
// module chunks = 94053359063892 107818501498521